import { templateLocationTypes } from '@qdabra/forms-shared';
import { getPiAttribute } from '../helpers/processingInstruction.helpers';
import makeTemplateLocation from './makeTemplateLocation';

// 2023-11-01 - Code moved from loader.js

const { LOCATION_TYPE_TEMPLATE_NAME, LOCATION_TYPE_XSN } =
    templateLocationTypes;

export function determineTemplateLocation(dom, overrideTemplateName) {
    const templateName =
        overrideTemplateName ||
        getPiAttribute(dom, 'QdabraFormsViewer', 'templateName');
    const href = getPiAttribute(dom, 'mso-infoPathSolution', 'href');

    if (templateName || href) {
        return { templateName, href };
    }

    throw new Error(
        'Unable to determine the template for the loaded document.',
    );
}

export const templateLocationsToLocation = ({ templateName, href }) => {
    if (templateName) {
        return makeTemplateLocation(templateName, LOCATION_TYPE_TEMPLATE_NAME);
    }

    if (href) {
        return makeTemplateLocation(href, LOCATION_TYPE_XSN);
    }

    // TODO: Throw error here?
    return null;
};
